import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { WINDOW } from '@app/common/app-tokens';
import { LinkModule } from '@app/directives/link.directive';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';

@Component({
  selector: 'app-refresh-prompt-dialog',
  templateUrl: './refresh-prompt-dialog.component.html',
  styleUrls: ['./refresh-prompt-dialog.component.scss']
})
export class RefreshPromptDialogComponent {

  showTitle = this.featureSettingsStoreService.state.showRefreshDialogTitle;

  constructor(@Inject(WINDOW) private window: Window, private featureSettingsStoreService: FeatureSettingsStoreService) { }

  refresh() {
    this.window.location.reload();
  }

}
@NgModule({
  declarations: [
    RefreshPromptDialogComponent
  ],
  entryComponents: [
    RefreshPromptDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    LinkModule,
  ]
})
export class RefreshPromptDialogModule { }
